import React from "react";
import { Field } from "formik";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import MultipleSelect from "features/Admin/components/NewMultipleSelect";

const GeneralForm = ({ centersFactory, samplersFactory, updateSamplers, updateCenters }) => (
	<div>
		<Field type="text" name="name" customlabel="Nom" component={CustomInputTextComponent} required />

		<MultipleSelect update={updateCenters} factory={centersFactory} />

		<MultipleSelect update={updateSamplers} factory={samplersFactory} />
	</div>
);

export default GeneralForm;
